import { render } from "./carriers.vue?vue&type=template&id=b60b0e6c"
import script from "./carriers.vue?vue&type=script&lang=js"
export * from "./carriers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__